import BackgroundImage from "@components/BackgroundImageCst";
import { Box, Container, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import Breadcrumb from "@components/Breadcrumb";
import HeroCst from "@components/HeroCst";
import AnimationFadeIn from "@components/AnimationFadeIn";
import { ServicesURL } from "@utils/utilsApi";
import ButtonBackPage from "@components/ButtonBackPage";
import { useParams } from "react-router-dom";
import { SelectCst } from "@components/InputCst";
import { useEffect, useState } from "react";
import { useAuth } from "@context/auth";
import { RolesDigitedEnum } from "@context/auth/types";
import useSWRMutation from "swr/mutation";
import { fetcher } from "src/services/config";
import { MethodType } from "src/services/type";

const DashboardVisualization: React.FC = () => {
  const theme = useTheme();
  const { t } = useTranslation(["dashboard-visualization-page", "common"]);
  const { id = "1" } = useParams();
  const { user } = useAuth();
  const [options, setOptions] = useState([]);
  const [value, setValue] = useState("");
  const [urlIframe, setUrlIframe] = useState("");
  const isPO = user?.roles.includes(RolesDigitedEnum.PRODUCT_OWNER);

  const { trigger: triggerDashboardDetail } = useSWRMutation(
    `${ServicesURL.getDashboard}?getUsersAndRoles=true&corporateId=${id}${isPO ? "" : `&userId=${user?.id_user}`}`,
    (url: string) => {
      return fetcher<any>(url, MethodType.GET);
    },
  );

  const getDashboardDetail = async (id?: string) => {
    const data = await triggerDashboardDetail();
    const optionsCalculated = data?.output?.map((opt: any) => {
      return {
        value: opt.id,
        label: opt.openLearningPlatformName || opt.originalName,
      };
    });
    setOptions(optionsCalculated);
    const selectedObj = data?.output?.find((opt: any) => opt.id === id);
    setUrlIframe(selectedObj?.quicksightUrl || data?.output[0]?.quicksightUrl);
    setValue(selectedObj?.id || data?.output[0]?.id);
  };

  useEffect(() => {
    getDashboardDetail();
  }, []);

  return (
    <AnimationFadeIn>
      <BackgroundImage
        customWidth={"100%"}
        customHeight={"603px"}
        image="section-dashboard.jpg"
        position={"absolute"}
        fullpage={true}
      />
      <Breadcrumb />
      <Container
        maxWidth={"xxl"}
        sx={{
          position: "relative",
          zIndex: 1,
        }}
      >
        <HeroCst title={t("hero-title")} description={t("hero-description")} />
        <Box
          sx={{
            [theme.breakpoints.up("md")]: {
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            },
          }}
        >
          <ButtonBackPage />
          <SelectCst
            id={"dashboard"}
            label={"Dashboard"}
            value={value}
            required={false}
            onChange={(e: any) => {
              getDashboardDetail(e);
            }}
            options={options}
            disabled={false}
            sx={{
              width: "100%",
              background: theme.palette.background.paper,
              [theme.breakpoints.up("md")]: {
                maxWidth: "400px",
              },
            }}
          />
        </Box>
        <Box
          sx={{
            mt: "25px",
            "& iframe": {
              border: 0,
            },
          }}
        >
          <iframe
            src={urlIframe}
            width={"100%"}
            height={"700px"}
            title="iframe"
          ></iframe>
        </Box>
      </Container>
    </AnimationFadeIn>
  );
};

export default DashboardVisualization;
